import { Link } from "react-router-dom";
import { useApp } from "@/lib/i18n";

export const Logo = ({ to = "/", light = false }) => {
  const { brand } = useApp();
  return (
    <Link to={to} className="flex items-center gap-2 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-500" data-testid="logo-link" aria-label={brand.app_name}>
      <span className="grid h-8 w-8 place-items-center rounded-xl" style={{ background: brand.navy_color }}>
        <span className="flex items-end gap-[2px]">
          {[6, 12, 9, 14].map((h, i) => (
            <span key={i} className="w-[3px] rounded-full" style={{ height: h, background: i === 3 ? brand.primary_color : "#fff" }} />
          ))}
        </span>
      </span>
      <span className={`font-heading text-lg font-extrabold tracking-tight ${light ? "text-white" : "text-slate-900"}`}>{brand.app_name}</span>
    </Link>
  );
};

export const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useApp();
  return (
    <div className={`inline-flex rounded-full border border-slate-200 bg-white p-0.5 text-xs font-semibold ${className}`} role="group" aria-label="Bahasa / Language">
      {["ms", "en"].map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          aria-pressed={lang === l}
          data-testid={`lang-toggle-${l}`}
          className={`rounded-full px-2.5 py-1 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-500 ${lang === l ? "bg-slate-900 text-white" : "text-slate-600 hover:text-slate-900"}`}
        >
          {l === "ms" ? "BM" : "EN"}
        </button>
      ))}
    </div>
  );
};

export const DemoBadge = () => (
  <span className="inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-amber-800" data-testid="demo-badge">
    Demo
  </span>
);
